import { render, staticRenderFns } from "./YtdItem.vue?vue&type=template&id=0dd4f1fe&scoped=true&"
import script from "./YtdItem.vue?vue&type=script&lang=js&"
export * from "./YtdItem.vue?vue&type=script&lang=js&"
import style0 from "./YtdItem.vue?vue&type=style&index=0&id=0dd4f1fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4f1fe",
  null
  
)

export default component.exports